import { AlignItems, Box, Display, JustifyContent } from '@gousto-internal/citrus-react'
import React from 'react'

import { useIsDesktopBreakpoint } from '../../../../hooks/useIsDesktopBreakpoint'
import { Carousel } from '../../../EndlessVarietySection/Carousel'
import { LandingPageContentSections } from '../../../../tracking'
import { CWCSupplierCard } from '../CWCSupplierCard/CWCSupplierCard'
import { cwcSupplierCardProps } from './cwcSupplierCarouselConfig'

const propertiesForTracking = {
  carouselSection: LandingPageContentSections.OUR_SUPPLIERS,
}

export function CWCSupplierCarousel() {
  const isDesktop = useIsDesktopBreakpoint()

  return (
    <Box
      width="100%"
      height="100%"
      display={Display.Flex}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.FlexStart}
    >
      <Carousel
        carouselAreaLabel="supplierCarousel"
        options={{ align: 'start', loop: false }}
        showNavButtons={isDesktop}
        autoHideNavButtons
        slidePaddingH={2}
        snowplowTrackingProperties={propertiesForTracking}
      >
        {cwcSupplierCardProps.map((supplierCard) => (
          <Box key={supplierCard.supplierDetails.title}>
            <CWCSupplierCard {...supplierCard} />
          </Box>
        ))}
      </Carousel>
    </Box>
  )
}
